import { content } from '../data/content';
import { BuyButton, SectionHeading } from './ui/Ui';

/** الميزة الأقوى تُعرض في بطاقة عريضة داكنة تمسك القسم بصرياً */
const LEAD = { icon: 'fa-bolt', title: content.feat2Title, desc: content.feat2Desc };

const FEATURES = [
  { icon: 'fa-shield', title: content.feat1Title, desc: content.feat1Desc },
  { icon: 'fa-droplet', title: content.feat3Title, desc: content.feat3Desc },
  { icon: 'fa-shirt', title: content.feat4Title, desc: content.feat4Desc },
  { icon: 'fa-up-down', title: content.feat5Title, desc: content.feat5Desc },
];

/**
 * شبكة غير متماثلة: بطاقة واحدة عريضة وداكنة تليها أربع بطاقات فاتحة.
 *
 * التصميم السابق كان خمس بطاقات بوزن واحد وخمسة ألوان أيقونات مختلفة —
 * أخضر وأحمر وأزرق وبرتقالي وكحلي — فبدا القسم كقوس قزح بلا تسلسل، ولا شيء
 * فيه يسبق غيره. هنا لونان فقط: كحلي وأبيض. الأحمر محجوز للألم وللزر، فلا
 * يتنافس معهما شيء. والبطاقة الداكنة الوحيدة تقول للعين من أين تبدأ.
 *
 * الصور حُذفت: كانت تدفع البطاقتين الأخيرتين لتصبحا ضعف ارتفاع غيرهما
 * فينكسر إيقاع الشبكة، والصورة داخل بطاقة ميزة لا تضيف معلومة جديدة.
 */
export default function Features() {
  return (
    <section id="features" className="scroll-mt-16 md:scroll-mt-20 py-10 md:py-20 bg-white">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.designedForYou}
          title={content.featuresTitle}
          highlight={content.featuresTitleHighlight}
          subtitle={content.featuresSubtitle}
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-6xl mx-auto">
          <div className="sm:col-span-2 rounded-3xl p-6 md:p-9 bg-gradient-to-br from-[#16456E] to-[#0C2941] ring-1 ring-white/10 shadow-xl shadow-z-navy/25 flex flex-col justify-center">
            <span className="w-12 h-12 rounded-2xl bg-white/10 text-white flex items-center justify-center text-xl mb-5">
              <i className={`fa-solid ${LEAD.icon}`} />
            </span>
            <h3 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-3">{LEAD.title}</h3>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md">{LEAD.desc}</p>
          </div>

          {FEATURES.map((feat) => (
            <div key={feat.title} className="bg-z-light rounded-3xl p-5 md:p-6">
              {/*
                الأيقونة بجانب العنوان لا فوقه: حين تنفرد بسطرها يبقى باقي
                السطر فارغاً — وهو فراغ واضح على الجوال حيث تمتدّ البطاقة
                بعرض الشاشة. المربّع الكحلي المصمت أوضح من الدائرة الفاتحة.
              */}
              <div className="flex items-center gap-3 mb-2.5">
                <span className="w-11 h-11 shrink-0 rounded-2xl bg-z-navy text-white flex items-center justify-center text-lg">
                  <i className={`fa-solid ${feat.icon}`} />
                </span>
                <h3 className="text-lg md:text-xl font-bold text-z-navy leading-snug">{feat.title}</h3>
              </div>
              <p className="text-z-gray text-[13px] md:text-sm leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10 md:mt-12">
          <BuyButton label={content.btnBuyNow} />
        </div>
      </div>
    </section>
  );
}
